export default {
    IncorrectFileType: /You can't upload files of this type./,
    FileTooBig: /File is too big/,
};
